// ==========================================================================
// MonaVida Pre-Lander — COMFORT angle — Interactive behaviours
// ==========================================================================

// 1. Scroll progress bar
const progressBar = document.getElementById('progressBar');

function updateProgress() {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
  if (progressBar) {
    progressBar.style.width = `${Math.min(progress, 100)}%`;
  }
}

// 2. Sticky mobile CTA — appears only AFTER the product reveal section
const stickyCta = document.getElementById('stickyCta');
const productSection = document.querySelector('.section-product');
let productRevealed = false;

if (stickyCta && productSection && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.boundingClientRect.bottom < 0) {
          productRevealed = true;
        } else if (entry.isIntersecting) {
          productRevealed = false;
          stickyCta.classList.remove('visible');
        }
      });
    },
    { threshold: [0, 1], rootMargin: '0px' }
  );
  observer.observe(productSection);
}

function updateStickyCta() {
  if (!stickyCta) return;
  if (productRevealed) {
    stickyCta.classList.add('visible');
  } else {
    stickyCta.classList.remove('visible');
  }
}

// 3. Throttled scroll listener
let ticking = false;
function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updateProgress();
      updateStickyCta();
      ticking = false;
    });
    ticking = true;
  }
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', updateProgress, { passive: true });

updateProgress();
updateStickyCta();

// 4. Mini-recommender — COMFORT-centric logic
const recommenderEl = document.getElementById('recommender');
const resultEl = document.getElementById('recommenderResult');
const steps = recommenderEl ? recommenderEl.querySelectorAll('.recommender-step') : [];
const dots = recommenderEl ? recommenderEl.querySelectorAll('.recommender-dot') : [];

function showStep(stepNum) {
  steps.forEach((s) => s.classList.remove('active'));
  dots.forEach((d, i) => {
    d.classList.toggle('active', i < stepNum);
    d.classList.toggle('current', i === stepNum - 1);
  });
  const target = recommenderEl.querySelector(`[data-step="${stepNum}"]`);
  if (target) target.classList.add('active');
}

if (recommenderEl && resultEl) {
  recommenderEl.addEventListener('change', (e) => {
    const stepNum = parseInt(e.target.closest('[data-step]')?.dataset.step, 10);

    setTimeout(() => {
      if (stepNum < 3) {
        showStep(stepNum + 1);
      } else {
        const q1 = recommenderEl.querySelector('input[name="q1"]:checked');
        const q2 = recommenderEl.querySelector('input[name="q2"]:checked');
        const q3 = recommenderEl.querySelector('input[name="q3"]:checked');
        if (!q1 || !q2 || !q3) return;

        const current = q1.value;
        const cynicism = q2.value;
        const duration = q3.value;

        // Line 1 — what you're escaping
        let currentLine = '';
        if (current === 'beugel')
          currentLine = 'Geen beugel meer. De 8 cm brede onderband neemt de steun over van de beugel — zonder dat iets in je zij prikt.';
        else if (current === 'bandjes')
          currentLine = 'Geen bandjes die alle druk dragen. De brede onderband verdeelt het gewicht over je hele romp — geen rode striemen, geen zware schouders.';
        else if (current === 'sportbra')
          currentLine = 'Geen sportbra-compromis meer. Je krijgt steun én een gescheiden cupvorm, zonder samendrukken of uniboob.';
        else
          currentLine = 'Je krijgt het lichte gevoel van een bralette — maar met de steun en vorm die een bralette nooit biedt.';

        // Line 2 — cynicism meets reassurance
        let cynicismLine = '';
        if (cynicism === 'paar')
          cynicismLine = 'Je hebt er al een paar geprobeerd — dus je weet hoe het voelt als het wéér tegenvalt. Daarom sturen we hem gratis terug als hij bij jou niet werkt. Geen verplichting.';
        else if (cynicism === 'veel')
          cynicismLine = 'Drie of meer mislukkingen — dat is precies het profiel van 7 op de 10 van onze klanten. 96% noemt dit hun meest comfortabele BH. Je staat niet alleen in de scepsis.';
        else
          cynicismLine = 'Een hele la vol is precies waar dit verhaal voor geschreven is. De meeste klanten hier hadden er nog meer. Je kijkt naar de juiste optie.';

        // Line 3 — duration
        let durationLine = '';
        if (duration === 'lang')
          durationLine = 'Bij 10+ uur per dag is de brede onderband essentieel — hij is specifiek ontworpen voor vrouwen die hun BH niet meer willen voelen na uur acht.';
        else if (duration === 'gemiddeld')
          durationLine = 'Bij een gemiddelde draagdag merk je het verschil vooral rond 15:00 — het moment waarop de meeste vrouwen bij andere BH&apos;s beginnen met rechttrekken.';
        else
          durationLine = 'Ook bij korter dragen maakt het verschil — geen bandjes die ingraven vanaf het eerste moment, geen aanpassings-ritueel.';

        resultEl.innerHTML = `
          <div class="rec-card">
            <span class="rec-eyebrow">Jouw persoonlijke aanbeveling</span>
            <h4 class="rec-title">De Daily Essential BH past bij jou</h4>
            <ul class="rec-reasons">
              <li>${currentLine}</li>
              <li>${cynicismLine}</li>
              <li>${durationLine}</li>
            </ul>
            <a href="https://monavida.nl/products/originele" class="button button-secondary rec-button">
              Bekijk de Daily Essential BH →
            </a>
            <p class="rec-note">30 dagen pasvormgarantie · Gratis ruilen · Altijd gratis verzending</p>
          </div>
        `;

        showStep('result');
        dots.forEach((d) => d.classList.add('active'));
      }
    }, 300);
  });
}

// 5. CTA click tracking placeholder (ready for Meta Pixel / GA4)
document.querySelectorAll('a[href*="monavida.nl"]').forEach((link) => {
  link.addEventListener('click', () => {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'prelander_cta_click',
        cta_text: link.textContent.trim(),
        cta_href: link.href,
      });
    }
  });
});

// ==========================================================================
// 6. Monavida Dashboard — Comfort Prelander Tracking
// ==========================================================================
(function() {
  var TRACK_ENDPOINT = 'https://monavida-dashboard.vercel.app/api/tracking/prelander';
  var TRACK_ID = 'prelander-comfort-v1';

  function trackEvent(event, data) {
    var vid = '', sid = '';
    try { vid = localStorage.getItem('mv_pl_vid') || ''; } catch(e) {}
    try { sid = sessionStorage.getItem('mv_pl_sid') || ''; } catch(e) {}
    fetch(TRACK_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prelander_id: TRACK_ID,
        visitor_id: vid,
        session_id: sid,
        event: event,
        data: data || {}
      }),
      keepalive: true
    }).catch(function(){});
  }

  // ─── Quiz Tracking ───
  var quizStarted = false;
  var quizAnswers = {};

  if (recommenderEl) {
    recommenderEl.addEventListener('change', function(e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var stepNum = parseInt(input.closest('[data-step]')?.dataset.step, 10);
      var question = input.name;
      var answer = input.value;
      quizAnswers[question] = answer;

      if (!quizStarted) {
        quizStarted = true;
        trackEvent('quiz_start', { question: question, answer: answer });
      }
      trackEvent('quiz_step', { step: stepNum, question: question, answer: answer });
      if (stepNum === 3) {
        trackEvent('quiz_complete', { answers: quizAnswers, q1: quizAnswers.q1 || '', q2: quizAnswers.q2 || '', q3: quizAnswers.q3 || '' });
      }
    });
  }

  // ─── Quiz Result CTA ───
  if (resultEl) {
    resultEl.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (link) {
        trackEvent('quiz_cta_click', { href: link.href, text: (link.textContent || '').trim().slice(0, 100), quiz_answers: quizAnswers });
      }
    });
  }

  // ─── FAQ Tracking ───
  document.querySelectorAll('.faq-item').forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (details.open) {
        var question = (details.querySelector('summary') || {}).textContent || '';
        trackEvent('faq_open', { question: question.trim().slice(0, 100) });
      }
    });
  });

  // ─── Sticky CTA Tracking ───
  var stickyTracked = false;
  if (stickyCta) {
    var stickyObserver = new MutationObserver(function() {
      if (stickyCta.classList.contains('visible') && !stickyTracked) {
        stickyTracked = true;
        trackEvent('sticky_cta_visible', { time_on_page: Math.round((Date.now() - performance.timing.navigationStart) / 1000) });
      }
    });
    stickyObserver.observe(stickyCta, { attributes: true, attributeFilter: ['class'] });

    stickyCta.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (link) {
        trackEvent('sticky_cta_click', { href: link.href, time_on_page: Math.round((Date.now() - performance.timing.navigationStart) / 1000) });
      }
    });
  }

  // ─── Specific CTA Type Tracking ───
  document.querySelectorAll('.mini-cta-inline').forEach(function(el) {
    el.addEventListener('click', function() {
      trackEvent('mini_cta_click', { text: (el.textContent || '').trim().slice(0, 100), href: el.href });
    });
  });

  var midCta = document.querySelector('.mid-cta a');
  if (midCta) {
    midCta.addEventListener('click', function() {
      trackEvent('mid_cta_click', { text: (midCta.textContent || '').trim().slice(0, 100) });
    });
  }

  var primaryCta = document.querySelector('.primary-cta .button-primary');
  if (primaryCta) {
    primaryCta.addEventListener('click', function() {
      trackEvent('primary_cta_click', { text: (primaryCta.textContent || '').trim().slice(0, 100) });
    });
  }

  // ─── Micro-yes Engagement ───
  var microYes = document.querySelector('.micro-yes');
  if (microYes && window.IntersectionObserver) {
    var microObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        trackEvent('micro_yes_seen', { time_on_page: Math.round((Date.now() - performance.timing.navigationStart) / 1000) });
        microObserver.disconnect();
      }
    }, { threshold: 0.8 });
    microObserver.observe(microYes);
  }

  // ─── Pullquote Engagement ───
  document.querySelectorAll('.pullquote').forEach(function(pq, i) {
    if (window.IntersectionObserver) {
      var pqObserver = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          trackEvent('pullquote_seen', { index: i + 1, text: (pq.textContent || '').trim().slice(0, 80) });
          pqObserver.disconnect();
        }
      }, { threshold: 0.8 });
      pqObserver.observe(pq);
    }
  });

  // ─── Stats Row (social proof) ───
  var statsRow = document.querySelector('.stats-row');
  if (statsRow && window.IntersectionObserver) {
    var statsObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        trackEvent('social_proof_seen', { time_on_page: Math.round((Date.now() - performance.timing.navigationStart) / 1000) });
        statsObserver.disconnect();
      }
    }, { threshold: 0.5 });
    statsObserver.observe(statsRow);
  }

  // ─── Testimonials ───
  document.querySelectorAll('.testimonial').forEach(function(t, i) {
    if (window.IntersectionObserver) {
      var tObserver = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          var author = (t.querySelector('.testimonial-author strong') || {}).textContent || '';
          trackEvent('testimonial_seen', { index: i + 1, author: author.trim() });
          tObserver.disconnect();
        }
      }, { threshold: 0.6 });
      tObserver.observe(t);
    }
  });

  console.log('[Monavida Prelander] Comfort tracking active for:', TRACK_ID);
})();
